<template>
    <div v-click-outside="hideVariablesTooltip" class="variables">
        <div v-on:click="toggleVariablesTooltip()"
             v-on:mouseenter="showTooltip = true"
             v-on:mouseleave="showTooltip = false"
             class="variables-popup-trigger">
            <strong>${...}</strong>
        </div>
        <tooltip v-bind:visible="showTooltip"
                 v-bind:position="popupPositionString"
                 v-bind:text="'Insert a Personalised variable for your establishment or the booking'"></tooltip>
        <div class="variables-popup" v-show="isShowVariablesTooltip">
            <div class="tooltip-container">
                <div class="tooltip-text tooltip-text--bottom-right text-left" v-bind:class="{'tooltip-visible' : true}">
                    <h5>Personalise this field with Variables</h5>
<!--                    <p>Personalise what the guest sees by adding <b>variables</b> to this field.-->
<!--                        The variables will be <b>replaced by values</b> from a Booking or Guest (or even your Establishment).</p>-->
<!--                    <p>Variables you can use in this field:</p>-->
                    <table class="variables-values">
                        <thead>
                            <th class="markdown-syntax__hdr-element">Variable</th>
                            <th class="markdown-syntax__hdr-syntax">Value</th>
                        </thead>
                        <tr v-for="(variable, index) in generalVariables" v-bind:key="'g' + index" v-on:click="injectVariable(variable)">
                            <td><span v-html="'${'"></span>{{variable.name}}<span v-html="'}'"></span></td>
                            <td>{{variable.value}}</td>
                        </tr>
                        <tr>
                            <td colspan="2" class="variables-values__heading">Property variables</td>
                        </tr>
                        <tr v-for="(variable, index) in roomTypeVariables" v-bind:key="'r' + index" v-on:click="injectVariable(variable)">
                            <td><span v-html="'${'"></span>{{variable.name}}<span v-html="'}'"></span></td>
                            <td>{{variable.value}}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Tooltip from '../Tooltip'

    import { variablesMixin } from '../../mixins/VariablesMixin'

    export default {
        name: 'Variables',
        components: {
            Tooltip
        },
        mixins: [ variablesMixin ],
        props: {
            variables: Array,
            obj: Object,
            propertyName: String,
            inputText: HTMLInputElement,
            inputTextArea: HTMLTextAreaElement,
            popupPosition: String
        },
        data: function() {
            return {
                showTooltip: false,
                input: null,
                isShowVariablesTooltip: false,
                canHideVariablesTooltip: false,
            }
        },
        computed: {
            popupPositionString: function() {
                if (this.popupPosition) {
                    return this.popupPosition;
                } else {
                    return 'bottom';
                }
            }
        },
        methods: {
            toggleVariablesTooltip: function() {
                this.isShowVariablesTooltip = !this.isShowVariablesTooltip;
                // only allow outside click events once the popup is showing
                this.canHideVariablesTooltip = false;
                setTimeout(() => {
                    this.canHideVariablesTooltip = true;
                }, 200);
            },
            hideVariablesTooltip: function() {
                if (this.canHideVariablesTooltip) {
                    this.isShowVariablesTooltip = false;
                    this.canHideVariablesTooltip = false
                }
            },
            injectVariable: function(variable) {
                if (this.input) {
                    let position = this.input.selectionStart;
                    if (position >= 0 && position <= this.obj[this.propertyName].length) {
                        if (position === 0) {
                            this.obj[this.propertyName] = "${" + variable.name + "}" + this.obj[this.propertyName];
                        } else if (position === this.obj[this.propertyName].length) {
                            this.obj[this.propertyName] = this.obj[this.propertyName] + "${" + variable.name + "}";
                        } else {
                            this.obj[this.propertyName] = this.obj[this.propertyName].slice(0, position) + "${" + variable.name + "}" + this.obj[this.propertyName].slice(position);
                        }
                        position = position + variable.name.length + 4;
                    }
                    this.$nextTick(() => {
                        this.input.setSelectionRange(position, position);
                        this.hideVariablesTooltip();
                        this.input.focus();
                    });
                }
            }
        },
        watch: {
            inputText: {
                handler: function () {
                    this.input = this.inputText;
                },
            },
            inputTextArea: {
                handler: function () {
                    this.input = this.inputTextArea;
                },
            },
            variables: {
                handler: function () {
                    if (this.variables) {
                        this.copyVariables(this.variables);
                    }
                }
            }
        },
        mounted() {
            if (this.variables) {
                this.copyVariables(this.variables);
            } else {
                this.fetchVariables();
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/layout/tooltips";
    @import "../../styles/components/variables";
</style>